const messageData = {
  userStatus: {
    registrationCompleted: {
      ko: '가입이 완료되었습니다.<br>승인 검토 후 가입하신 메일을 통해 안내드리겠습니다.',
      en: 'Your registration is complete.<br>After reviewing, we will inform you via email.'
    },
    pendingAccount: {
      ko: '승인 대기중인 계정입니다.',
      en: 'This account is pending for approval.'
    },
    declinedAccount: {
      ko: '승인 거절된 계정입니다.',
      en: 'This account has been declined.'
    },
    cancelSignUp: {
      ko: '회원가입 취소',
      en: 'Cancel membership'
    },
    requestReapproval: {
      ko: '재승인 요청',
      en: 'Request reapproval'
    },
    signUpCancelled: {
      ko: '회원가입이 취소되었습니다.',
      en: 'Membership has been cancelled.'
    },
    reapprovalRequested: {
      ko: '재승인이 요청되었습니다.',
      en: 'Reapproval requested.'
    },
    cancelSignUpMessage: {
      ko: '회원가입을 취소하시겠습니까?<br>취소시 가입 내용이 삭제됩니다.',
      en: 'Are you sure you want to cancel membership?<br>When you cancel, your subscription will be deleted.'
    }
  },
  signIn: {
    notSignedUp: {
      ko: '가입되지 않은 계정입니다.',
      en: 'You have not signed up.'
    },
    checkPasswordAgain: {
      ko: '비밀번호를 다시 확인해주세요.',
      en: 'Please check your password again.'
    },
    deletedAccount: {
      ko: '이미 삭제된 계정입니다.',
      en: 'Account has already been deleted.'
    }
  },
  signUp: {
    subsidiary: {
      ko: '계열사',
      en: 'Subsidiary'
    },
    enterprise: {
      ko: '회사',
      en: 'Enterprise'
    },
    department: {
      ko: '부서',
      en: 'Department'
    },
    countryCode: {
      ko: '국가 코드',
      en: 'Country code'
    },
    haveAccount: {
      ko: '이미 계정이 있으신가요?',
      en: 'Already have an account?'
    },
    checkAvailability: {
      ko: '이메일 Available Check를 해주세요.',
      en: 'Please check email availability.'
    },
    availableEmail: {
      ko: '사용 가능한 이메일입니다.<br>이메일로 받은 인증코드를 입력해주세요.',
      en: 'Email Available.<br>Enter the certification code you received in the email.'
    },
    approvedEmail: {
      ko: '이미 승인된 이메일입니다.',
      en: 'Already approved email.'
    },
    declinedEmail: {
      ko: '이미 승인거절된 이메일입니다.',
      en: 'Email has already been disapproved.'
    },
    pendingEmail: {
      ko: '이미 승인대기중인 이메일입니다.',
      en: 'This email is already pending approval.'
    },
    deletedAccount: {
      ko: '이미 삭제된 계정입니다.',
      en: 'Account has already been deleted.'
    },
    requestSent: {
      ko: '요청되었습니다.',
      en: 'Request has send.'
    },
    alreadyRegistered: {
      ko: '이미 신청되었거나 허가된 이메일 도메인입니다.',
      en: 'This email domain is already requested or allowed.'
    }
  },
  myInfo: {
    changeInfo: {
      ko: '회원정보 변경',
      en: 'Change member information'
    },
    changePassword: {
      ko: '비밀번호 변경',
      en: 'Change password'
    },
    currentPassword: {
      ko: '현재 비밀번호',
      en: 'Current Password'
    },
    newPassword: {
      ko: '새 비밀번호',
      en: 'New Password'
    },
    confirmNewPassword: {
      ko: '새 비밀번호 확인',
      en: 'Confirm New Password'
    },
    infoUpdated: {
      ko: '변경된 정보가 저장되었습니다.',
      en: 'The changes have been saved.'
    }
  },
  recoverPassword: {
    noMatchedAccountMessage: {
      ko: '입력하신 정보와 일치하는 계정이 없습니다.',
      en: 'No account matches the information you entered.'
    },
    sentResetLink: {
      ko: '{email}로 비밀번호 재설정 링크를 전송하였습니다.',
      en: 'Password reset link has been sent to {email}.'
    },
    isNotSent: {
      ko: '메일이 발송되지 않았나요?',
      en: 'You haven\'t recieved email?'
    },
    // edited
    resend: {
      ko: '재발송 하기',
      en: 'Resend'
    },
    emailResent: {
      ko: '재발송되었습니다.',
      en: 'An email has been resent.'
    },
    signUp: {
      ko: '회원가입',
      en: 'Sign Up'
    },
    reEnter: {
      ko: '다시 입력',
      en: 'Re-enter'
    }
  },
  resetPassword: {
    newPassword: {
      ko: '새 비밀번호',
      en: 'New password'
    },
    confirmNewPassword: {
      ko: '새 비밀번호 확인',
      en: 'Confirm new password'
    },
    change: {
      ko: '변경하기',
      en: 'Change'
    },
    noAccountForUrl: {
      ko: 'URL에 해당하는 계정이 없습니다.',
      en: 'No account exists for URL.'
    },
    passwordChanged: {
      ko: '비밀번호가 변경되었습니다.',
      en: 'Your password has been changed.'
    }
  },
  manageMember: {
    manageMember: {
      ko: '회원관리',
      en: 'Members Management'
    },
    approvalPending: {
      ko: '승인 대기',
      en: 'Approval Pending'
    },
    approvalPendingCount: {
      ko: '승인 대기 {count}명',
      en: 'Pending Approval : {count}'
    },
    approveSelected: {
      ko: '선택 승인',
      en: 'Approve Selected Items'
    },
    declineSelected: {
      ko: '선택 거절',
      en: 'Decline Selected Items'
    },
    function: {
      ko: '기능',
      en: 'Function'
    },
    select: {
      ko: '선택',
      en: 'Select'
    },
    noResult: {
      ko: '검색 결과가 없습니다.',
      en: 'No results found.'
    },
    noApprovalPending: {
      ko: '승인 요청 계정이 없습니다.',
      en: 'No accounts pending for approval.'
    },
    memberInfo: {
      ko: '회원 정보',
      en: 'Members Information'
    },
    totalMemberCount: {
      ko: '전체 회원 {count}명',
      en: 'Total Members : {count}'
    },
    deleteAccount: {
      ko: '계정 삭제',
      en: 'Delete Account'
    },
    noMember: {
      ko: '가입한 회원이 없습니다.',
      en: 'No members.'
    },
    deleteSelected: {
      ko: '선택 삭제',
      en: 'Delete Selected Items'
    },
    approved: {
      ko: '승인되었습니다.',
      en: 'Account has been approved.'
    },
    declined: {
      ko: '거절되었습니다.',
      en: 'Account has been declined.'
    },
    approveAccountMessage: {
      ko: '해당 계정을 승인하시겠습니까?',
      en: 'Are you sure you want to approve this account?'
    },
    declineAccountMessage: {
      ko: '해당 계정을 거절하시려면 승인 거절 사유를 선택해주세요.',
      en: 'To decline this account, please select the reason for declination.'
    },
    approveSelectedAccountMessage: {
      ko: '선택된 계정을 승인하시겠습니까?',
      en: 'Are you sure you want to approve the selected account?'
    },
    declineSelectedAccountMessage: {
      ko: '선택된 계정을 거절하시려면 승인 거절 사유를 선택해주세요.',
      en: 'To decline selected account(s), please select the reason for declination.'
    },
    deleteUserMessage: {
      ko: '해당 계정을 삭제하시겠습니까?',
      en: 'Are you sure you want to delete this account?'
    },
    deleteSelectedUserMessage: {
      ko: '선택된 계정을 삭제하시겠습니까?',
      en: 'Are you sure you want to delete the selected accounts?'
    },
    defaultRejectReason: {
      ko: '잘못된 신청입니다. 관리자에게 문의해주세요.',
      en: 'Invalid application. Please contact the administrator.'
    },
    rejectReasonMinChar: {
      ko: '5자 이상 입력해주세요.',
      en: 'Please enter at least 5 characters.'
    }
  },
  dashboard: {
    deleteGroupMessage: {
      ko: '해당 그룹을 삭제하시겠습니까?',
      en: 'Are you sure you want to delete this group?'
    },
    deletePageMessage: {
      ko: '해당 페이지를 삭제하시겠습니까?',
      en: 'Are you sure you want to delete this page?'
    },
    noPages: {
      ko: '저장된 페이지가 없습니다.',
      en: 'There are no pages saved.'
    }
  },
  diagnostics: {
    advancedOptions: {
      ko: '진단 고급 옵션',
      en: 'Diagnostics Advanced Options'
    },
    excludeElements: {
      ko: '제외할 요소',
      en: 'Elements to Exclude'
    },
    excludeSelectors: {
      ko: '진단에서 제외할 요소의 Selector Path를 선택해주세요.',
      en: 'Select the Selector Path of the element to exclude from the diagnosis.'
    },
    includeElements: {
      ko: '진단할 요소',
      en: 'Elements to Diagnosis'
    },
    includeSelectors: {
      ko: '진단 대상인 요소의 Selector Path를 선택해주세요. 다른 요소는 진단되지 않습니다.',
      en: 'Select the Selector Path of the element to diagnosis. Other elements will be ignored.'
    },
    requireLogin: {
      ko: '로그인 필요 페이지',
      en: 'Login Required Page'
    },
    enterLoginInfo: {
      ko: '페이지에 접근하기 위한 로그인 정보를 입력해주세요.',
      en: 'Please enter the login information to access the page.'
    },
    resolutionSettings: {
      ko: '진단 해상도 설정',
      en: 'Diagnostic Resolution Settings'
    },
    resolutionSettingsShort: {
      ko: '해상도 설정',
      en: 'Resolution Settings'
    },
    minimumPixel: {
      ko: '{minPx}px 이상',
      en: '{minPx}px or higher'
    },
    maximumPixel: {
      ko: '{maxPx}px 이하',
      en: '{maxPx}px or lower'
    },
    diagnosing: {
      ko: '진단중',
      en: 'Diagnosing'
    },
    viewReport: {
      ko: '리포트 보기',
      en: 'View Report'
    },
    createdAt: {
      ko: '등록 일시',
      en: 'Registered Date'
    },
    editGroupOk: {
      ko: '그룹 수정 완료',
      en: 'Finish Editing Group'
    },
    enterNewGroupName: {
      ko: '추가할 새 그룹명을 입력해주세요.',
      en: 'Please enter a new group name to add.'
    },
    reDiagnosis: {
      ko: '다시 진단',
      en: 'Re-diagnosis'
    },
    diagnosisProcessing: {
      ko: '진행 중인 진단이 존재합니다.',
      en: 'Diagnosis is already processing.'
    },
    diagnosisFailed: {
      ko: '진단에 실패하였습니다. 다시 시도해주세요.<br>문제가 지속되면 관리자에게 문의바랍니다.',
      en: 'Diagnosis failed. Please try again.<br>If the problem persists, please contact the administrator.'
    },
    navigationFailed: {
      ko: 'URL 탐색에 실패했습니다. URL이 올바른지 확인해주세요.',
      en: 'Navigate to URL failed. Please make sure the URL is correct.'
    },
    navigationExpired: {
      ko: 'URL 탐색이 만료되었습니다. 다시 시도해주세요.<br>문제가 지속되면 관리자에게 문의바랍니다.',
      en: 'URL navigation has expired. Please try again.<br>If the problem persists, please contact the administrator.'
    },
    loginFailed: {
      ko: '로그인에 실패했습니다. 로그인 URL과 선택자를 확인하시고 다시 시도해주세요.<br>문제가 지속되면 관리자에게 문의바랍니다.',
      en: 'Login failed. Please check the login URL and selectors and try again.<br>If the problem persists, please contact the administrator.'
    },
    cancelDiagnosis: {
      ko: '정말 진단을 취소하시겠습니까?',
      en: 'Are you sure you want to cancel the diagnosis?'
    },
    closeOptions: {
      ko: '진단 고급 옵션을 닫으시겠습니까?<br>옵션을 닫을시 항목이 초기화됩니다.',
      en: 'Are you sure you want to close the Diagnostics Advanced Options?<br>When the option is closed, items are initialized.'
    },
    reportSavedMessage: {
      ko: '저장되었습니다.<br>그룹 목록으로 이동하시겠습니까?',
      en: 'Saved.<br>Do you want to move to the group list?'
    },
    emptyId: {
      ko: 'ID를 입력해주세요.',
      en: 'Please enter ID.'
    },
    emptyPassword: {
      ko: '비밀번호를 입력해주세요.',
      en: 'Please enter PW.'
    }
  },
  report: {
    loginInfo: {
      ko: '로그인 정보',
      en: 'Login Information'
    },
    excludeElements: {
      ko: '제외할 요소',
      en: 'Elements to Exclude'
    },
    includeElements: {
      ko: '진단할 요소',
      en: 'Elements to Diagnosis'
    },
    set: {
      ko: '설정됨',
      en: 'Set'
    },
    noCaptureRect: {
      ko: '이슈에 해당하는 캡쳐 영역 확인 불가<br><span>코드를 확인해주세요</span>',
      en: 'Cannot verify capture area corresponding to issue<br><span>Please check code</span>'
    },
    notAvailable: {
      ko: '해당 없음',
      en: 'N/A'
    },
    all: {
      ko: '전부',
      en: 'All'
    },
    deletePageMessage: {
      ko: '해당 페이지를 삭제하시겠습니까?',
      en: 'Are you sure you want to delete this page?'
    },
    noIssues: {
      ko: '해당 이슈 없음',
      en: 'No issue'
    }
  },
  saveReport: {
    // added
    group: {
      ko: '그룹',
      en: 'Group'
    },
    newGroup: {
      ko: '새 그룹',
      en: 'New Group'
    },
    pageName: {
      ko: '페이지명',
      en: 'Page Name'
    },
    reportDataExist: {
      ko: '동일한 설정의 진단 이력이 존재합니다.',
      en: 'Diagnostic history of the same setting exists.'
    }
  },
  shareReport: {
    pageName: {
      ko: '페이지명',
      en: 'Page Name'
    },
    setPassword: {
      ko: '비밀번호 설정',
      en: 'Set Password'
    },
    // added
    password: {
      ko: '비밀번호',
      en: 'Password'
    },
    createLink: {
      ko: '링크 생성',
      en: 'Create Link'
    },
    shareLink: {
      ko: '공유 링크',
      en: 'Share Link'
    },
    copyLink: {
      ko: '링크 복사',
      en: 'Copy Link'
    },
    copied: {
      ko: '복사되었습니다.',
      en: 'Copied'
    },
    emptyPassword: {
      ko: '비밀번호를 입력해주세요.',
      en: 'Please enter a password.'
    }
  },
  sharedReport: {
    enterPassword: {
      ko: '공유된 리포트는 암호로 보호되어 있습니다. 확인하시려면 암호를 입력해주세요.',
      en: 'Shared report is password-protected. Please enter your password to confirm.'
    },
    sharedReport: {
      ko: '공유된 리포트',
      en: 'Shared Report'
    },
    deletedReport: {
      ko: '삭제된 리포트입니다.',
      en: 'This is a deleted report.'
    },
    checkPassword: {
      ko: '비밀번호를 다시 확인해주세요.',
      en: 'Please check your password again.'
    },
    readOnlyMessage: {
      ko: `이 페이지는 '보기'만 가능합니다.{0}더 많은 기능을 사용하시려면 {1}해야 합니다.`,
      en: `This page can only be viewed.{0}You need to {1} for more features.`
    },
    signIn: {
      ko: '로그인',
      en: 'SIGN IN'
    }
  },
  common: {
    confirm: {
      ko: '확인',
      en: 'Confirm'
    },
    cancel: {
      ko: '취소',
      en: 'Cancel'
    },
    yes: {
      ko: '네',
      en: 'Yes'
    },
    no: {
      ko: '아니오',
      en: 'No'
    },
    delete: {
      ko: '삭제',
      en: 'Delete'
    },
    save: {
      ko: '저장',
      en: 'Save'
    },
    approve: {
      ko: '승인',
      en: 'Approve'
    },
    decline: {
      ko: '거절',
      en: 'Decline'
    },
    deleted: {
      ko: '삭제되었습니다.',
      en: 'Deleted.'
    },
    // added
    updated: {
      ko: '변경되었습니다.',
      en: 'Updated'
    },
    withoutDash: {
      ko: '\'-\'없이 입력해주세요.',
      en: 'Please enter without \'-\''
    },
    signIn: {
      ko: '로그인',
      en: 'Sign in'
    },
    enterDirect: {
      ko: '직접 입력',
      en: 'Enter Directly'
    },
    openNewWindow: {
      ko: '새창으로 열기',
      en: 'Open in a New Window'
    }
  },
  system: {
    operationFailed: {
      ko: '작업에 실패했습니다',
      en: 'Operation failed'
    },
    pageNotFound: {
      ko: '존재하지 않는 페이지입니다.',
      en: 'This page does not exist.'
    },
    wrongApproach: {
      ko: '잘못된 접근입니다.',
      en: 'Wrong approach.'
    }
  },
  validation: {
    emptyEmail: {
      ko: '이메일을 입력해주세요.',
      en: 'Please enter your email.'
    },
    invalidEmail: {
      ko: '올바른 메일주소를 입력해주세요.',
      en: 'Please enter a valid email address.'
    },
    emptyCertification: {
      ko: '인증코드를 입력해주세요.',
      en: 'Please enter the certification code.'
    },
    notVerifiedEmail: {
      ko: '올바른 인증코드를 입력해주세요.',
      en: 'Please enter the correct certification code.'
    },
    notAllowedEmail: {
      ko: '허가되지 않은 이메일 도메인입니다.<br>관리자에게 연락하세요: <a href="mailto:{adminEmail}">{adminEmail}</a>',
      en: 'Unauthorized domain (email).<br>Contact admin: <a href="mailto:{adminEmail}">{adminEmail}</a>'
    },
    emptyPassword: {
      ko: '비밀번호를 입력해주세요.',
      en: 'Please enter your password.'
    },
    invalidPassword: {
      ko: '적절한 비밀번호를 입력해주세요.',
      en: 'Please enter a valid password.'
    },
    passwordNotMatch: {
      ko: '비밀번호와 일치하지않습니다.',
      en: 'The password does not match.'
    },
    // not used
    // emptyCurrentPassword: {
    //   ko: '현재 비밀번호를 입력해주세요.',
    //   en: 'Please enter current password.'
    // },
    currentPasswordNotMatch: {
      ko: '현재 비밀번호와 일치하지않습니다.',
      en: 'It does not match the current password.'
    },
    invalidNewPassword: {
      ko: '적절한 비밀번호를 입력해주세요.',
      en: 'Please enter a valid password.'
    },
    newPasswordNotMatch: {
      ko: '새 비밀번호와 일치하지않습니다.',
      en: 'It does not match the new password.'
    },
    emptyEnterprise: {
      ko: '기업 유형을 선택해주세요.',
      en: 'Please select an subsidiary type.'
    },
    emptyEnterpriseInfo: {
      ko: '기업 정보를 선택해주세요.',
      en: 'Please select enterprise information.'
    },
    emptyDepartment: {
      ko: '부서 정보를 입력해주세요.',
      en: 'Please enter department information.'
    },
    emptyFirstName: {
      ko: '이름을 입력해주세요.',
      en: 'Please enter your first name.'
    },
    emptyLastName: {
      ko: '성을 입력해주세요.',
      en: 'Please enter your last name.'
    },
    emptyCountryCode: {
      ko: '국가코드를 선택해주세요.',
      en: 'Please select country code.'
    },
    emptyPhone: {
      ko: '전화번호를 입력해주세요.',
      en: 'Please enter your phone number.'
    },
    // not used
    // numbersOnly: {
    //   ko: '숫자만 입력해주세요.',
    //   en: 'Please enter numbers only.'
    // },
    invalidPhone: {
      ko: '8~12자리의 숫자를 입력해주세요.',
      en: 'Please enter a number between 8 and 12 digits.'
    },
    emptyFields: {
      ko: '모든 칸을 빠짐없이 입력해주세요.',
      en: 'Please fill out all the fields.'
    },
    invalidUrl: {
      ko: 'URL이 올바르지 않습니다.',
      en: 'The URL is not valid.'
    },
    invalidLoginUrl: {
      ko: '로그인 URL이 올바르지 않습니다.',
      en: 'Login URL is not valid.'
    },
    emptyGroupName: {
      ko: '새 그룹명을 입력해주세요.',
      en: 'Please enter a new group name.'
    },
    emptyPageName: {
      ko: '페이지명을 입력해주세요.',
      en: 'Please enter a page name.'
    },
    existSameGroup: {
      ko: '동일한 그룹명이 존재합니다.',
      en: 'The same group name exists.'
    },
    emptyExcludeSelectors: {
      ko: 'Selector Path를 선택해주세요.',
      en: 'Select the Selector Path.'
    }
  }
}

function getI18nMessages (locale) {
  const data = {}
  data[locale] = {}

  for (const [mainKey, mainValue] of Object.entries(messageData)) {
    for (const [subKey, subValue] of Object.entries(mainValue)) {
      if (!data[locale][mainKey]) {
        data[locale][mainKey] = {}
      }

      data[locale][mainKey][subKey] = subValue[locale]
    }
  }
  return data
}

export default getI18nMessages



// WEBPACK FOOTER //
// ./src/data/i18n-message.js